import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_DASHBOARD } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'

const defaultSummary = {
  totalActiveWorkflows: 0,
  overdueTasksCount: 0,
  tasksDueTodayCount: 0,
  tasksDueThisWeekCount: 0
}

const workflowDashboard = {
  namespaced: true,
  state: buildInitialState({
    summary: { ...defaultSummary }
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowDashboardSummary ({ commit, dispatch }) {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: `${PATH_WORKFLOW_DASHBOARD}/summary` })
        .then(json => json.data)
        .then(summary => {
          commit('updateStatus', { status: COMPLETE })
          commit('setSummary', summary)
          return summary
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load workflow dashboard summary')
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setSummary (state, summary) {
      state.summary = summary || { ...defaultSummary }
    }
  }
}

export default workflowDashboard
